import React from "react";
import Hero from "../components/Hero";
import BeliefsAndMinistries from "../components/BeliefAndMinistries";
import MinistriesSection from "../components/MinistriesSection";
import WatchStory from "../components/WatchStory";

export default function AboutPage() {
  return (
    <div className="bg-[#1A1F2B] text-white w-full min-h-screen flex flex-col items-center">
      
      {/* Section 1: Hero */}
      <Hero   title="Who We Are"
  description={`
Moriah Church is a Christ-centered ministry rooted in the Word of God. We are committed to proclaiming biblical truth, nurturing spiritual growth, empowering women, mentoring youth, and equipping believers to walk in the fullness of their calling in Christ."
`}/>
 <BeliefsAndMinistries/>
      {/* Section 2: Mission & Vision */}
      {/* <section className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-6 py-14 rounded-t-3xl" data-aos="fade-up">
        <div className="max-w-5xl mx-auto space-y-6">
          <h2 className="text-3xl font-bold text-center text-[#1A1F2B]">
            Our Mission & Vision
          </h2>

          <p className="text-lg leading-relaxed">
            At Moriah Church, Prarthana Bhawan, our mission is to cultivate
            a Christ-centered and Spirit-led environment where people from
            all walks of life can encounter the living God through
            authentic worship, biblical teaching, and fervent prayer.
          </p>

          <p className="text-lg leading-relaxed">
            We are committed to building a loving and supportive faith
            community that encourages genuine fellowship, nurtures
            spiritual maturity, and empowers individuals to grow in their
            relationship with Jesus Christ. Through discipleship, service,
            and compassionate outreach, we seek to strengthen families and
            equip believers to live out their faith in everyday life.
          </p>

          <p className="text-lg leading-relaxed">
            Our vision is to be a Christ-centered haven where hearts are
            spiritually nourished, faith is strengthened, and lives are
            transformed by the power of God’s presence. We aspire to be a
            vibrant and welcoming community of believers who grow together
            in love, unity, and purpose, reflecting Christ’s love and hope
            in word and action.
          </p>
        </div>
      </section> */}

      {/* Section 3: YouTube Video Section */}
      {/* <section className="w-full bg-[#1A1F2B] px-6 py-14">
        <h2 className="text-3xl font-bold mb-6 text-center text-[#D9A05B]" data-aos="fade-up">
          Watch Our Story
        </h2>
        <div className="flex justify-center">
          <iframe
            className="w-full max-w-2xl h-64 md:h-96 rounded-xl shadow-lg border-2 border-[#C9A86A]"
            src="/Images/video.mp4"
            title="Moriah Church Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </section> */}
      <WatchStory/>
      <MinistriesSection/>

      {/* Section 4: Social Outreach */}
      {/* <section className="w-full bg-[#D2CBC3] text-[#1A1F2B] px-6 py-14 rounded-t-3xl" data-aos="fade-up">
        <div className="max-w-5xl mx-auto space-y-6">
          <h2 className="text-3xl font-bold text-center">
            Our Outreach & Social Impact
          </h2>

          <p className="text-lg leading-relaxed">
            As a Gospel-centered church, we are committed to ensuring that
            the message of Jesus Christ reaches every home and every
            heart. Through social media and digital platforms, we share
            teachings, worship sessions, and messages that encourage
            spiritual growth.
          </p>

          <p className="text-lg leading-relaxed">
            We also serve the poor, the needy, and the destitute with love
            and compassion. If people cannot reach us, we make sure we
            reach them. Our youth are encouraged to use their God-given
            talents—whether in music, media, or leadership—to glorify God
            and serve the community.
          </p>
        </div>
      </section> */}

      {/* Section 5: Facebook Photos Section */}
      <section className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-6 py-14" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-center mb-8">
          Moments From Our Church
        </h2>

        <p className="text-center mb-8 text-lg max-w-3xl mx-auto leading-relaxed">
          Experience the heart of Moriah Church through moments of worship,
          fellowship, and community life. These memories reflect the
          faith, devotion, and unity that define our church family.
        </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" data-aos="fade-up">
  <img 
    className="rounded-xl shadow-lg" 
    src="/Images/memo1.jpg" 
    alt="Worship service at Moriah Church in Delhi" 
  />
  
  <img 
    className="rounded-xl shadow-lg" 
    src="/Images/memo2.jpg" 
    alt="Church congregation during prayer session" 
  />
  
  <img 
    className="rounded-xl shadow-lg" 
    src="/Images/memo3.jpg" 
    alt="Believers gathered for Sunday worship" 
  />
</div>
      </section>

    </div>
  );
}
